export var getExtensionType = function getExtensionType(extension) {
  var properties = extension.properties;
  if ((properties === null || properties === void 0 ? void 0 : properties.layout) === 'bodied') {
    return 'bodiedExtension';
  } else if ((properties === null || properties === void 0 ? void 0 : properties.layout) === 'inline') {
    return 'inlineExtension';
  }
  return 'extension';
};